module.exports = __webpack_public_path__ + "static/media/orchid.1424a51e.png";


//////////////////
// WEBPACK FOOTER
// ./src/Features/orchid.png
// module id = 28
// module chunks = 0